import React, { useState, useEffect } from 'react';
import { PaystackButton } from 'react-paystack';
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from '../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import '../styles/fundWallet.css';

const PaystackPaymentForm = () => {
  const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;

  // State for form values
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [amount, setAmount] = useState(0);

  const amountInKobo = amount * 100;

  // Get the authenticated user
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);

        // Fetch user details from Firestore
        try {
          const userDocRef = doc(db, "users", currentUser.uid);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            setName(userData.displayName || '');
            setEmail(userData.email || '');
          } else {
            console.error("No user data found in Firestore.");
          }
        } catch (error) {
          console.error("Error fetching user data from Firestore:", error);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  // Function to handle successful payments
  const handleSuccess = (response) => {
    if (!user) {
      alert("User is not authenticated!");
      return;
    }

    // Backend webhook will process the payment safely and add balance.
    alert(`Payment successful! Reference: ${response.reference}. Your payment is processing and will reflect in your wallet momentarily.`);
    window.location.href = "/account";
  };

  const componentProps = {
    email,
    amount: amountInKobo,
    publicKey,
    metadata: {
      custom_fields: [
        {
          display_name: "User ID",
          variable_name: "user_id",
          value: user?.uid || "",
        }
      ]
    },
    text: "Pay Now",
    onSuccess: handleSuccess,
    onClose: () => alert("Payment window closed"),
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!email || !name || amount <= 0) {
      alert("Please fill all fields and enter a valid amount");
      return;
    }
  };

  return (
    <div className='bg-light2 dark:bg-dark1 text-dark0 dark:text-light1 space-y-6 w-full py-4 px-8 rounded-md'>
      <h3>Fund your Wallet</h3>
      <hr className="border-dark0 w-full" />
      <form onSubmit={handleSubmit} className="space-y-2 fund-wallet-form">
        <div className="">
          <label>Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className='outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full'
          />
        </div>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className='outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full'
          />
        </div>
        <div className="">
          <label>Amount (NGN):</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
            className='outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full'
          />
        </div>
        <div></div>
        <br />
        <PaystackButton {...componentProps} />
      </form>
    </div>
  );
};

export default PaystackPaymentForm;











// import React, { useState, useEffect } from 'react';
// import { PaystackButton } from 'react-paystack';
// import { collection, addDoc, doc, getDoc } from "firebase/firestore";
// import { db, auth } from '../firebase/firebaseConfig';
// import { onAuthStateChanged } from 'firebase/auth';
// import '../styles/fundWallet.css';

// const PaystackPaymentForm = () => {
//   // Replace with your Paystack public key
//   const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;

//   // State for form values
//   const [user, setUser] = useState(null);
//   const [email, setEmail] = useState('');
//   const [name, setName] = useState('');
//   const [amount, setAmount] = useState(0);

//   // Convert amount to kobo (multiply by 100) since Paystack expects the smallest currency unit
//   const amountInKobo = amount * 100;

//   // Get the authenticated user
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (currentUser) {
//         setUser(currentUser);

//         // Fetch user details from Firestore
//         try {
//           const userDocRef = doc(db, "users", currentUser.uid);
//           const userDoc = await getDoc(userDocRef);

//           if (userDoc.exists()) {
//             const userData = userDoc.data();
//             setName(userData.displayName || '');
//             setEmail(userData.email || '');
//           } else {
//             console.error("No user data found in Firestore.");
//           }
//         } catch (error) {
//           console.error("Error fetching user data from Firestore:", error);
//         }
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   // Function to handle successful payments and save transactions
//   const handleSuccess = async (response) => {
//     try {
//       if (!user) {
//         alert("User is not authenticated!");
//         return;
//       }

//       // Reference to the user's transactions collection in Firestore
//       const userTransactionsRef = collection(db, `users/${user.uid}/transactions`);

//       // Add the transaction document, including Paystack reference ID
//       await addDoc(userTransactionsRef, {
//         name,
//         mobileNumber: '',
//         amount: parseInt(amount, 10),
//         network: "",
//         type: 'deposit',
//         response, // Store the full response object for additional details
//         timestamp: new Date(),
//       });

//       alert(`Payment successful! Transaction saved. Reference: ${response.reference}`);
//     } catch (error) {
//       console.error("Error saving transaction:", error);
//       alert("Payment successful, but failed to save the transaction!");
//     }
//   };

//   const componentProps = {
//     email,
//     amount: amountInKobo,
//     publicKey,
//     text: "Pay Now",
//     onSuccess: handleSuccess,
//     onClose: () => alert("Payment window closed"),
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     if (!email || !name || amount <= 0) {
//       alert("Please fill all fields and enter a valid amount");
//       return;
//     }
//   };

//   return (
//     <div className='bg-light2 dark:bg-dark1 text-dark0 dark:text-light1 space-y-6 w-full py-4 px-8 rounded-md'>
//       <h3>Fund your Wallet</h3>
//       <hr className="border-dark0 w-full" />
//       <form onSubmit={handleSubmit} className="space-y-2 fund-wallet-form">
//         <div className="">
//           <label>Name:</label>
//           <input
//             type="text"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             required
//             className='outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full'
//           />
//         </div>
//         <div>
//           <label>Email:</label>
//           <input
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//             className='outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full'
//           />
//         </div>
//         <div className="">
//           <label>Amount (NGN):</label>
//           <input
//             type="number"
//             value={amount}
//             onChange={(e) => setAmount(e.target.value)}
//             required
//             className='outline-none border-none dark:bg-dark2 rounded-md h-10 px-2 w-full'
//           />
//         </div>
//         <div></div>
//         <br />
//         <PaystackButton {...componentProps} />
//       </form>
//     </div>
//   );
// };

// export default PaystackPaymentForm;
